import { Plus, Trash2 } from "lucide-react";
import { MESES_ABREV } from "../../utils/orcamento";

// Inflação/reajustes dos itens por período (faixas) — usado pelo "Novo item" de Despesas Gerais
// (ModalNovoItemSimples) e de Custos Gerais por Projeto (ModalItem). Mesma regra do formulário
// legado: o percentual passa a valer no mês cadastrado e fica composto nos meses seguintes,
// sobre o valor do período vigente (cálculo no backend, fator_reajuste_no_mes).

export function reajustesIniciais(item) {
  return (item?.reajustes || []).map((r) => ({ tipo_indice: r.tipo_indice, mes: r.mes, percentual: r.percentual }));
}

// Linha com algum campo preenchido mas não todos — bloqueia o salvar (em vez de sumir calada).
export function temReajusteIncompleto(reajustes) {
  return reajustes.some((r) => {
    const preenchidos = [r.tipo_indice, r.mes, r.percentual].filter((v) => v !== "" && v !== null && v !== undefined).length;
    return preenchidos > 0 && (preenchidos < 3 || Number.isNaN(parseFloat(r.percentual)));
  });
}

export function reajustesParaPayload(reajustes) {
  return reajustes
    .filter((r) => r.tipo_indice && r.mes && r.percentual !== "" && !Number.isNaN(parseFloat(r.percentual)))
    .map((r) => ({ tipo_indice: r.tipo_indice, mes: Number(r.mes), percentual: parseFloat(r.percentual) }));
}

export default function ReajustesFaixasEditor({ C, reajustes, onChange }) {
  const input = {
    background: C.bg, border: `1px solid ${C.border}`, borderRadius: 8,
    padding: "9px 12px", fontSize: 13, color: C.text, fontFamily: "inherit", outline: "none", width: "100%",
  };

  function atualizar(idx, campo, valor) {
    onChange(reajustes.map((r, i) => (i === idx ? { ...r, [campo]: valor } : r)));
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <label style={{ fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", color: C.muted }}>
          Inflação / Reajustes
        </label>
        <button
          type="button"
          onClick={() => onChange([...reajustes, { tipo_indice: "", mes: "", percentual: "" }])}
          style={{
            display: "flex", alignItems: "center", gap: 4, background: "transparent",
            border: `1px solid ${C.border}`, borderRadius: 6, padding: "4px 10px",
            color: C.brand, fontSize: 11, fontWeight: 700, cursor: "pointer", fontFamily: "inherit",
          }}
        >
          <Plus size={12} /> Adicionar reajuste
        </button>
      </div>
      {reajustes.length === 0 && (
        <p style={{ margin: 0, fontSize: 11, color: C.muted, fontStyle: "italic" }}>
          Nenhum reajuste cadastrado — o item usa os valores dos períodos sem correção.
        </p>
      )}
      {reajustes.map((r, i) => (
        <div key={i} style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr auto", gap: 8, alignItems: "center" }}>
          <select style={input} value={r.tipo_indice} onChange={(e) => atualizar(i, "tipo_indice", e.target.value)}>
            <option value="">Tipo…</option>
            <option value="inflacao">Inflação</option>
            <option value="reajuste">Reajuste</option>
          </select>
          <select style={input} value={r.mes} onChange={(e) => atualizar(i, "mes", e.target.value)}>
            <option value="">Mês…</option>
            {MESES_ABREV.map((m, idx) => <option key={m} value={idx + 1}>{m}</option>)}
          </select>
          <input style={input} type="number" step="0.01" placeholder="% Ex: 4,00" value={r.percentual}
            onChange={(e) => atualizar(i, "percentual", e.target.value)} />
          <button
            type="button"
            title="Remover reajuste"
            onClick={() => onChange(reajustes.filter((_, idx) => idx !== i))}
            style={{ background: "none", border: "none", cursor: "pointer", color: C.danger, display: "inline-flex" }}
          >
            <Trash2 size={13} />
          </button>
        </div>
      ))}
      {reajustes.length > 0 && (
        <p style={{ margin: 0, fontSize: 11, color: C.muted }}>
          O percentual vale a partir do mês escolhido e acumula com os reajustes seguintes, sobre o valor do período vigente.
        </p>
      )}
    </div>
  );
}
